// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"7a7835a1","312":"c562eb4f","453":"0d00c8d4","484":"0cf08bcf","551":"9158d1c0","842":"4dfba246"}[chunkId] + ".chunk.js";
};